module.exports = __webpack_public_path__ + "static/media/csm-bumper_selected.3d506b4e.svg";